export const DATATEST = {
    ROOT: "reusable__select-field-component",
    LABEL: "reusable__select-field-component__label",
    ERROR_ICON: "reusable__select-field-component__error-icon",
    ERROR_MESSAGE: "reusable__select-field-component__error-message",
};
